// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useQuery } from '@tanstack/react-query';
import { useHttpClient, type HttpClientInstance } from '@toggl/sync/http';
import type {} from '../types';
import { createQueryOptions } from '../utils/queries';
import {
  getCareersPageQueryKey,
  getPublicCareersOpeningsQueryKey,
  getPublicCareersPageQueryKey,
} from './keys';
import {
  getCareersPage,
  getPublicCareersOpenings,
  getPublicCareersPage,
} from './requests';

/**
 * Get public careers page by subdomain.
 */
export function getPublicCareersPageQueryOptions(
  httpClient: HttpClientInstance,
  subdomain: string,
  enabled?: boolean
) {
  return createQueryOptions({
    queryKey: getPublicCareersPageQueryKey(subdomain),
    queryFn: ({ signal }) =>
      getPublicCareersPage(httpClient, subdomain, signal),
    enabled,
  });
}
/**
 * Get public careers page by subdomain.
 */
export function useGetPublicCareersPage(subdomain: string, enabled?: boolean) {
  const httpClient = useHttpClient();
  return useQuery(
    getPublicCareersPageQueryOptions(httpClient, subdomain, enabled)
  );
}

/**
 * List public openings in a careers page.
 */
export function getPublicCareersOpeningsQueryOptions(
  httpClient: HttpClientInstance,
  subdomain: string,
  enabled?: boolean
) {
  return createQueryOptions({
    queryKey: getPublicCareersOpeningsQueryKey(subdomain),
    queryFn: ({ signal }) =>
      getPublicCareersOpenings(httpClient, subdomain, signal),
    enabled,
  });
}
/**
 * List public openings in a careers page.
 */
export function useGetPublicCareersOpenings(
  subdomain: string,
  enabled?: boolean
) {
  const httpClient = useHttpClient();
  return useQuery(
    getPublicCareersOpeningsQueryOptions(httpClient, subdomain, enabled)
  );
}

/**
 * Get careers page contents of workspace.
 */
export function getCareersPageQueryOptions(
  httpClient: HttpClientInstance,
  workspaceId: number,
  enabled?: boolean
) {
  return createQueryOptions({
    queryKey: getCareersPageQueryKey(workspaceId),
    queryFn: ({ signal }) => getCareersPage(httpClient, workspaceId, signal),
    enabled,
  });
}
/**
 * Get careers page contents of workspace.
 */
export function useGetCareersPage(workspaceId: number, enabled?: boolean) {
  const httpClient = useHttpClient();
  return useQuery(getCareersPageQueryOptions(httpClient, workspaceId, enabled));
}
